<template>
  <modal
    centered
    :is-back-button-enabled="false"
    @close="$emit('close')"
  >
    <template slot="body">
      <BaseLoading v-if="isPoolStandingsLoading" />
      <div v-else>
        <b-row :class="$style.border">
          <b-col>
            <BaseTextH2 class="text-center pb-2 m-0'">
              {{ $t('my-pool-predictions-overview') }}
            </BaseTextH2>
          </b-col>
        </b-row>
        <b-row
          v-for="user in poolStandings"
          :key="`user-pool-overview-${user.id}`"
          :class="[
            'py-2',
            $style.wrapper,
            $style.border,
            user.isMe && $style.isMyPosition
          ]"
        >
          <b-col
            :cols="6"
            :md="8"
            :lg="9"
            class="d-flex align-items-center"
          >
            <BaseAvatar
              :size="75"
              :url="user.avatar.image_url"
              is-lazy
            />
            <div class="px-2">
              <span :class="$style.nameWrapper">
                <template v-if="user.isMe">{{ $t('you') }}</template>
                <template v-else>{{ user.name }}</template>
              </span>
              <span :class="$style.scoreTextWrapper">{{ $t('score') }}:&nbsp;</span>
              <span :class="$style.scoreWrapper">{{ user.score }}</span>
            </div>
          </b-col>
          <b-col
            :cols="6"
            :md="4"
            :lg="3"
            class="d-flex flex-column justify-content-center align-items-center"
          >
            <div
              v-if="user.prediction"
              :class="$style.statusWrapper"
            >
              <font-awesome-icon icon="check" />
              {{ $t('ready') }}
            </div>
            <div
              v-else
              :class="[
                $style.statusWrapper,
                $style.noPrediction
              ]"
            >
              <font-awesome-icon icon="times" />
              {{ $t('no-prediction') }}
            </div>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-center pt-3">
          <BaseButton
            is-rounded
            class="d-flex"
            size="sm"
            @click="$emit('close')"
          >
            <span class="px-2">{{ $t('close') }}</span>
          </BaseButton>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Modal from '@/components/Molecules/Modal'
import BaseAvatar from '@/components/Atoms/BaseAvatar'
import BaseLoading from '@/components/Atoms/BaseLoading'
import BaseButton from '@/components/Atoms/BaseButton'
import BaseTextH2 from '@/components/Atoms/Typography/BaseTextH2'

export default {
  name: 'TheUpcomingRoundPoolOverviewModal',
  components: {
    BaseTextH2,
    BaseButton,
    BaseLoading,
    BaseAvatar,
    Modal,
  },
  props: {
    roundId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapState({
      isPoolStandingsLoading: state => state['rounds/summer/poolStandings'].isPoolStandingsLoading,
    }),
    poolStandings() {
      return this.$store.getters['rounds/summer/poolStandings/getRoundPullStandings'](this.roundId)
    },
  },
  created() {
    this.fetchRoundPoolStandings({
      roundId: this.roundId,
    })
  },
  methods: {
    ...mapActions({
      fetchRoundPoolStandings: 'rounds/summer/poolStandings/fetchRoundPoolStandings',
    }),
  },
}
</script>

<style module lang="scss">
  @import "../../../../../../assets/scss/variables";
  .border {
    border-bottom: 2px solid $color-bleached-silk;
  }
  .wrapper {
    transition: all .3s ease-in-out;
    .nameWrapper {
      display: block;
      font-weight: 600;
    }
    .scoreWrapper {
      color: $color-tomato;
      font-weight: 600;
    }
    .statusWrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      white-space: nowrap;
      color: $color-bubble-bobble-green;
      font-size: $font-size-small;
      font-weight: 600;
      &.noPrediction {
        color: $color-tomato;
      }
    }
  }
</style>
